import {
  BpkButtonV2,
  BUTTON_TYPES,
  SIZE_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import MinusIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/minus';
import PlusIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/plus';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './ZoomControl.module.scss';

const cls = cssModules(STYLES);

type ZoomControlProps = {
  onCollapse: () => void;
  onExpand: () => void;
  zoomInLabel?: string;
  zoomOutLabel?: string;
};

const ZoomControl = ({
  onCollapse,
  onExpand,
  zoomInLabel = 'Zoom in',
  zoomOutLabel = 'Zoom out',
}: ZoomControlProps) => (
  <div className={cls('ZoomControl')}>
    <BpkButtonV2
      type={BUTTON_TYPES.primaryOnDark}
      size={SIZE_TYPES.small}
      iconOnly
      onClick={onExpand}
      className={cls('ZoomControl__button')}
      aria-label={zoomInLabel}
    >
      <PlusIcon />
    </BpkButtonV2>
    <BpkButtonV2
      type={BUTTON_TYPES.primaryOnDark}
      size={SIZE_TYPES.small}
      iconOnly
      onClick={onCollapse}
      className={cls('ZoomControl__button')}
      aria-label={zoomOutLabel}
    >
      <MinusIcon />
    </BpkButtonV2>
  </div>
);

export default ZoomControl;
